export default __webpack_public_path__ + "static/hours-24ff5172666bf531b5ba8728318b1fec.svg";